module.exports = __webpack_public_path__ + "static/media/distribuicao-6.631c9b8c.jpg";